import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=466233e6"
import script from "./testing.vue?vue&type=script&lang=js"
export * from "./testing.vue?vue&type=script&lang=js"
import style0 from "./testing.vue?vue&type=style&index=0&id=466233e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports